// Heights for scroll triggers
const ef_viewportHeight = window.ef_viewportHeight = window.innerHeight;
let ef_pageHeight = window.ef_pageHeight = document.body.clientHeight;

const ef_main = window.ef_main = document.querySelector(".ef-content");
let ef_mainHeight = ef_main ? window.ef_mainHeight = ef_main.offsetHeight : 0;

const ef_footer = window.ef_footer = document.querySelector(".ef-footer");
let ef_footerHeight = ef_footer ? window.ef_footerHeight = ef_footer.offsetHeight : 0;

let ef_isInView = function(el) {
  if (!el) return false; // Schutz, falls el null ist
  let { top, bottom } = el.getBoundingClientRect();
  const vHeight = window.innerHeight || document.documentElement.clientHeight;

  return (top > 0 || bottom > 0) && top < vHeight;
};

function ef_addIsInViewClass(el) {
  if (el) {
    window.setTimeout(() => el.classList.add("--is-in-view"), 500);
  }
}

function ef_viewportCheck(els) {
  const elements = document.querySelectorAll(els);

  elements.forEach((el) => {
    if (ef_isInView(el)) {
      ef_addIsInViewClass(el);
    }

    window.addEventListener(
      "scroll",
      () => {
        if (ef_isInView(el)) {
          ef_addIsInViewClass(el);
        }
      },
      false
    );
  });
}

const ef_jsViewportCheck = document.querySelectorAll(".js-viewport-check");
if (ef_jsViewportCheck.length > 0) {
  ef_viewportCheck(".js-viewport-check");
}

// Check if footer is in viewport
window.addEventListener("scroll", () => {
  const ef_scrollTop = document.documentElement.scrollTop;

  if (ef_footerHeight > 0) {
    if (ef_scrollTop > ef_pageHeight - ef_viewportHeight - ef_footerHeight) {
      document.body.classList.add("--footer-visible");
    } else {
      document.body.classList.remove("--footer-visible");
    }

    if (ef_scrollTop > ef_pageHeight - ef_viewportHeight - ef_footerHeight * 2) {
      document.body.classList.add("--footer-nearby");
    } else {
      document.body.classList.remove("--footer-nearby");
    }
  }
});
